export default {
  name: 'CoreFavoritcard',
  props: {
    item: {
      type: Object,
      required: true
    },
    tileSizeSetting: {
      type: Number,
      required: true,
      default: 0
    },
    componentKey: {
      type: Number,
      required: true
    }
  },
  computed: {}
};